import { render } from "./EducationConfigSetting.vue?vue&type=template&id=3ada32cc&scoped=true"
import script from "./EducationConfigSetting.vue?vue&type=script&lang=js"
export * from "./EducationConfigSetting.vue?vue&type=script&lang=js"

import "./EducationConfigSetting.vue?vue&type=style&index=0&id=3ada32cc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada32cc"]])

export default __exports__